/* frame-style-color-default.js
 *
 * Fix: on this store, "Stretched Canvas" only comes in White, while
 * "Floating Frame" and "Standard Fiber Frame" come in all five colors.
 * The theme's variant picker only updates the photo/price when the
 * selected Size + Frame Style + Frame Color combination matches a real
 * variant. If a shopper picks a Frame Style while an incompatible Frame
 * Color is still selected (e.g. switching to Stretched Canvas while Black
 * is selected), no variant matches, and the page silently freezes on
 * whatever was showing before.
 *
 * This script enforces a simple, predictable default whenever Frame Style
 * changes: White for Stretched Canvas, Black for the other two styles. It
 * does this by checking the correct Frame Color radio and dispatching a
 * native 'change' event on it, so the theme's own existing variant-picker
 * code (unchanged) picks it up and updates the image/price normally.
 */
(function () {
  'use strict';

  function defaultColorFor(frameStyleValue) {
    return frameStyleValue === 'Stretched Canvas' ? 'White' : 'Black';
  }

  function findColorRadio(root, colorValue) {
    var radios = root.querySelectorAll('input[data-index="option3"], input[name="frame-color"]');
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].value === colorValue) {
        return radios[i];
      }
    }
    return null;
  }

  function onFrameStyleChange(event) {
    var target = event.target;
    if (!target || target.value == null) {
      return;
    }

    var frameStyleValues = ['Floating Frame', 'Standard Fiber Frame', 'Stretched Canvas'];
    if (frameStyleValues.indexOf(target.value) === -1) {
      return;
    }

    var form = target.closest('form') || document;
    var desiredColor = defaultColorFor(target.value);
    var colorRadio = findColorRadio(form, desiredColor);

    if (colorRadio && !colorRadio.checked) {
      colorRadio.checked = true;
      var changeEvent = document.createEvent('HTMLEvents');
      changeEvent.initEvent('change', true, true);
      colorRadio.dispatchEvent(changeEvent);
    }
  }

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || target.tagName !== 'INPUT' || target.type !== 'radio') {
      return;
    }
    if ((target.id || '').indexOf('ProductSelect-option-frame-style') === 0 || target.name === 'frame-style') {
      onFrameStyleChange(event);
    }
  });
})();
